import React, {Component, PropTypes} from "react";
import {Link} from "react-router";
import {connect} from "react-redux";
import {GetForingLang, GetOneLanguage, GetAllLanguage, AddForingLang, DelLearningLang} from "../../actions/index";

class LanguageLearning extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.editLang = this.editLang.bind(this);
        this.delLangOpenModal = this.delLangOpenModal.bind(this);
        this.addLang = this.addLang.bind(this);
        this.delLang = this.delLang.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.AddLangFromModal = this.AddLangFromModal.bind(this);
        this.addLangNew = this.addLangNew.bind(this);
        this.renderSelect = this.renderSelect.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetForingLang(token);
        this.props.GetAllLanguage(token);
    }
    componentDidMount(){
        $('#AddLang').on('show.bs.modal', function () {
            $('.selectpicker').selectpicker();
        })
    }
    addLangNew(){
        $('#AddLang').modal('hide');
        this.context.router.push('/language/all/add/');
    }
    addLang(){
        $('#AddLang').modal('show');
    }
    AddLangFromModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        this.props.AddForingLang(token, $('#select').val()).then((response)=>{
            if(response.payload.status == 201){
                this.closeModal('AddLang');
                this.props.GetForingLang(token);
            }
        })
    }
    editLang(id, item){
        this.context.router.push('/language/learning/edit/'+id);
    }
    delLangOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelLang').modal('show');
        $('#DelLang').on('shown.bs.modal', function () {
            $('#for_id').val(item);
            that.props.GetOneLanguage(id, token);
        });
    }
    delLang(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelLearningLang(token, $('#for_id').val()).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal('DelLang');
                $('#for_id').val('')
                this.props.GetForingLang(token);
            }
        });
    }
    closeModal(id, item){
        $('#'+ id).modal('hide');
        this.props.lang.lang_one = {};
    }
    renderTable(){
        return this.props.lang.foring_lang.results.map((item, i)=>{
            return(
                <div key={item.id} className="white-block common-list four clearfix">
                    <p>{i+1}</p>
                    <p><span className="link-span" onClick={this.editLang.bind(this, item.id)}>{item.lang.name}</span></p>
                    <p>{item.is_active ? <span className="btn btn-success">Active</span>: <span className="btn btn-danger">Inactive</span>}</p>
                    <p>
                        <button type="button" onClick={this.editLang.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true" />
                        </button>
                        <button type="button" onClick={this.delLangOpenModal.bind(this, item.lang.id, item.id)}>
                            <span className="span glyphicon glyphicon-trash" />
                        </button>
                    </p>
                </div>
            )
        })
    }
    renderSelect(){
        return this.props.lang.all_lang.results.map((item)=>{
            return <option key={item.id} value={item.id}>{item.name}</option>
        })
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix"><p className="pull-left">Learning Languages</p>
                    <button onClick={this.addLang} type="button" className="pull-right btn btn-primary">
                        <span className="glyphicon glyphicon-plus" aria-hidden="true" />
                        Add learning language
                    </button>
                </div>
                {this.props.lang.foring_lang.results && this.props.lang.foring_lang.results.length > 0 ?
                    <div>
                        <div className="col-md-12">
                            <div className="common-list four clearfix">
                                <p>#</p>
                                <p>Language</p>
                                <p>Status</p>
                                <p>Option</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            { this.renderTable() }
                        </div>
                    </div>
                    :
                    <div className={this.props.lang.foring_lang.results && this.props.lang.foring_lang.results.length < 0 || $.isEmptyObject(this.props.lang.foring_lang) ? "for_preloader" : 'for_preloader dn'}>
                        <div className="preloader-wrapper big active">
                            <div className="spinner-layer spinner-blue-only">
                                <div className="circle-clipper left">
                                    <div className="circle" />
                                </div>
                                <div className="gap-patch">
                                    <div className="circle" />
                                </div>
                                <div className="circle-clipper right">
                                    <div className="circle" />
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.props.lang.foring_lang.results && this.props.lang.foring_lang.results.length === 0 && <p className="noResults">No items result</p>}

                <div className="modal fade" id="DelLang" tabIndex="-1" role="dialog" aria-labelledby="DelLangLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal.bind(this, 'DelLang')} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelLang"></span>
                                <p>Do you really want to delete this language {this.props.lang.lang_one ? <span>{this.props.lang.lang_one.name}</span> : ""}?</p>
                                <input type="text" hidden="hidden" id="for_id"/>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal.bind(this, 'DelLang')} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delLang} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="AddLang" tabIndex="-1" role="dialog" aria-labelledby="AddLangLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal.bind(this, 'AddLang')} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <p className="title">Add learning language</p>
                            </div>
                            <div className="modal-body text-center">
                                <div>
                                    <label htmlFor="select">Choose language</label>
                                    {this.props.lang.all_lang.results ?
                                        <select name="select" className="selectpicker form-control" data-live-search="true" id="select">
                                            {this.renderSelect()}
                                        </select>
                                        :
                                        ""
                                    }
                                </div>
                                <div className="newAdd clearfix">
                                    <p>Haven't found the language?
                                        <button type="button" onClick={this.addLangNew} className="btn btn-primary"><span className="glyphicon glyphicon-plus" aria-hidden="true"></span>Add language</button>
                                    </p>
                                </div>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal.bind(this, 'AddLang')} type="button" className="btn btn-default">Cancel</button>
                                <button onClick={this.AddLangFromModal} type="button" className="btn btn-primary">Add</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="clearfix"></div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetForingLang, GetOneLanguage, GetAllLanguage, AddForingLang, DelLearningLang})(LanguageLearning);


// WEBPACK FOOTER //
// ./src/components/language/learning.js